const React = require('react');
const useUserInputsRendererController = require('./useUserInputsRendererController');
const UserInputsRendererPropTypes = require('./UserInputsRendererPropTypes');

function UserInputsRenderer(props) {

    const {
        children,
        formMethods,
        getSignupDetails,
        renderFields,
        submit,
        uiState
    } = useUserInputsRendererController(props);

    if (typeof children !== 'function') {
        return null;
    }

    return children({
        formMethods,
        getSignupDetails,
        renderFields,
        uiState,
        submit
    });
}

UserInputsRenderer.propTypes = UserInputsRendererPropTypes;

module.exports = UserInputsRenderer;
